import React from 'react';

interface Props {
    status: number;
    box: number;
    translations: {[key: string]: string};
}

const ConsultantStatus: React.FC<Props> = ( { translations, status, box } ) => {
    const GetStatusSpan = () => {
        switch ( status ) {
            case 1:
                return <span className={ "status" } style={ { color: "#00b900" } }>{ translations["status_available"] }</span>
            default:
                return <></>
        }
    }

    return <span>
        { GetStatusSpan() }
        { box > 0 && <>
            <br/>
            <span className={ "box" }>Box: <b>{ box }</b></span>
        </> }
    </span>

}

export default ConsultantStatus;